import React from "react";
import { Marker } from "react-map-gl";
import MarkersStyle from "components/CityMap/CityMarkers.module.css";
import PieChartBase from "components/PieChart/PieChartBase"
import {  scaleLog } from "d3-scale";
const Markers = ({
  data,
  setShowPopup,
  setLatFocus,
  setLngFocus,
  setOffsetFocus,
  setTooltip,
  colorRange,
  minCount,
  maxCount,
  minRadius,
  maxRadius,
  zoomedIn
}) => {
  const maxOffset = 30;
  const minOffset = 10;
  // const minRadius = 11;
  // const maxRadius = 22;
  function getSum(total, value){
    return total + value
  }
  const markers = data.map(
    ({ location, value,   lat: latStr, lng: lngStr ,lineageList}) => {
      let count=lineageList.map(item=>item.value).reduce(getSum, 0)
      let radius = scaleLog()
        .domain([minCount, maxCount])
        .range([minRadius, maxRadius])(count);
      let offset = Math.max(
        minOffset,
        maxOffset
      );
      if (isNaN(offset)) {
        offset = 0;
      }
      let lat = parseFloat(latStr);
      let lng = parseFloat(lngStr);
      if (!zoomedIn) {
        switch(location){
          case "Beijing":lng -= 2;lat-=0.8
          case "Tianjin":lng += 0.5
          case "Jiangsu":lat+=1.3
          case "Fujian":lat-=0.8
        }

        // if (location == 'Beijing') lng -= 1.2
        // if (location == 'Tianjin') lng += 0.5

      }
      return !isNaN(lat) && !isNaN(lng) ? (
        <Marker
          key={location}
          offsetTop={-offset*1.5}
          offsetLeft={-offset}
          latitude={lat}
          longitude={lng}
        >
          <PieChartBase location={location} lineageData={lineageList} colorRange={colorRange} radius={radius} lat={lat}/>
          {/* <div
            className={`${MarkersStyle.marker}`}
            style={{
              background: '#FF0000',
              opacity: 1,
              height: radius,
              width: radius,
            }}
            onMouseEnter={(e) => {
              setLatFocus(lat);
              setLngFocus(lng);
              setOffsetFocus(-(radius / 2));
              setShowPopup(true);
              setTooltip(`${city}: ${count} `);
            }}
            onMouseLeave={() => {
              setShowPopup(false);
            }}
          /> */}
        </Marker>
      ) : null;
    }
  );
  return markers;
};

export default React.memo(Markers);
